import React, { useState } from 'react';
import { Card, CardContent, useMediaQuery } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { t } from 'src/i18n';
import VerifyIdentityForm from './components/VerifyIdentity.form';
import PrimaryButton from 'src/components/PrimaryButton/PrimaryButton.component';
import Routes from '../Navigator/Navigator.route';
import {
  useStyles,
  CenterRow,
  Header,
  CardWrapper,
  CardTitle,
  TextCenter,
  ButtonBackWrapper,
  ButtonBackToLogin
} from './VerifyIdentity.style';
import MainLogo from 'src/components/MainLogo/MainLogo';
import { parseJSON } from 'src/utils/common.util';

interface IProps {
  setStepVerify(step: number): void;
}

const VerifyIdentityView: React.FC<IProps> = ({ setStepVerify }) => {
  const classes = useStyles();
  const [isRegisterSuccessful, setRegisterSuccessful] = useState<boolean>(
    false
  );
  const history = useHistory();

  const handleBackToSignIn = () => {
    history.push(Routes.SignIn);
  };

  const matches = useMediaQuery('(max-width:768px)')
  const isIpadLg = useMediaQuery('(max-width:1024px)')

  const isTablet = matches || isIpadLg

  return (
    <div>
      <Header>
        <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
      </Header>
      {!isRegisterSuccessful && (
        <div className={classes.pdl10}>
          <ButtonBackToLogin onClick={handleBackToSignIn}>
            ← {t('register.successful.buttonBack')}
          </ButtonBackToLogin>
        </div>
      )}
      <CardWrapper>
        {isRegisterSuccessful ? (
          <Card className={classes['card-success']}>
            <CardContent>
              <CardTitle>{t('register.successful.title')}</CardTitle>
              <TextCenter className={classes.mb20}>
                {t('register.successful.description')}
              </TextCenter>
              <CenterRow>
                <ButtonBackWrapper>
                  <PrimaryButton
                    onClick={handleBackToSignIn}
                    variant="contained"
                    isShowIcon={true}
                    title={t('register.successful.buttonBack')}
                  />
                </ButtonBackWrapper>
              </CenterRow>
            </CardContent>
          </Card>
        ) : (
          <Card className={isTablet ? classes['width80%'] : classes['width30%']}>
            <CardContent>
              <CardTitle>{t('register.title')}</CardTitle>
              <VerifyIdentityForm setStepVerify={setStepVerify} />
            </CardContent>
          </Card>
        )}
      </CardWrapper>
    </div>
  );
};

export default VerifyIdentityView;
